// src/components/BecomeAMember.js
import React from 'react';

const BecomeAMember = () => {
  const handleSubscription = () => {
    window.location.href = '/gocardless-direct-debit';
  };

  const handleDispatchSubscription = () => {
    window.location.href = 'https://pay.gocardless.com/BRT00042HGFHETE';
  };

  return (
    <div className="container my-5">
      {/* Hero / CTA */}
      <div className="text-center p-5 mb-5 rounded shadow" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="mb-4">
          <img src="/logo192.png" alt="Taxi-Local.uk" style={{ maxWidth: '150px' }} />
        </div>
        <h1 className="fw-bold mb-2">Join Taxi-Local.uk Network</h1>
        <p className="lead mb-4">
          Built by a Taxi Operator, Just Like You
        </p>
        <div className="mb-3">
          <span className="badge bg-danger fs-6">1st month only £1</span>
        </div>
        <button
          className="btn btn-success btn-lg"
          onClick={handleDispatchSubscription}
        >
          Join Now - Start Earning More
        </button>
      </div>

      {/* Membership Options Section */}
      <div className="container mt-5 px-3">
        <div className="card mb-4">
          <div className="card-header bg-warning text-center">
            <h2 className="mb-0">Join Taxi-Local.uk Network</h2>
          </div>
          <div className="card-body text-center">
                         <p className="mb-4">
               We're building a smarter way for independent local firms across East Devon and West Dorset to 
               work together, save time, and pick up more fares—without the hassle of constant phone calls or quoting.
               <strong>Initially in East Devon, West Dorset and Somerset.</strong>
             </p>
          </div>
        </div>

        {/* Key Benefits Section */}
        <div className="card mb-4">
          <div className="card-header bg-success text-white text-center">
            <h4 className="mb-0">Why Choose Taxi-Local.uk Over International Platforms?</h4>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <h5 className="text-success">✅ Keep More of Your Earnings</h5>
                <p>
                  <strong>No 25%+ Commission!</strong> Unlike international platforms that take 25-30% of every fare, 
                  we charge just 75p per accepted job. That's it. Keep your hard-earned money in your pocket.
                </p>
                
                <h5 className="text-success">✅ Local Network, Local Support</h5>
                <p>
                  Built by local taxi operators who understand your challenges. We're not a faceless corporation—we're your neighbors.
                </p>
                
                <h5 className="text-success">✅ Instant Lead Distribution</h5>
                <p>
                  Journey requests from local passengers sent directly to your device. No waiting, no delays, just immediate opportunities.
                </p>
                
                <h5 className="text-success">✅ Smart Diary Management</h5>
                <p>
                  Safe, secure, and always available online diary. Lost your diary? Just log in. Never lose a booking again.
                </p>
                
                <h5 className="text-success">✅ Work with Trusted Colleagues</h5>
                <p>
                  Accept, pass, or share jobs with nearby operators you know and trust. Build relationships, not just transactions.
                </p>
                
                <h5 className="text-success">⭐ Customer Review System</h5>
                <p>
                  <strong>Build your reputation!</strong> Customers can rate their experience with detailed 6-criteria reviews. 
                  View your ratings and feedback to improve service. Track customer history and blacklist problematic customers 
                  with full audit trails.
                </p>
                
                <h5 className="text-success">📍 Real-Time Location Tracking</h5>
                <p>
                  <strong>Always know where you are!</strong> Automatic GPS tracking integrated with job monitoring. 
                  Your location updates automatically, helping you respond to nearby jobs faster.
                </p>
                
                <h5 className="text-success">🚨 Automatic Job Alerts</h5>
                <p>
                  <strong>Never miss an opportunity!</strong> Job Monitor automatically checks for new jobs in your postcode areas 
                  every 5 minutes. Get instant screen flash, sound, and email alerts when work becomes available.
                </p>
              </div>
              
              <div className="col-md-6">
                <h5 className="text-success">✅ Professional Receipts</h5>
                <p>
                  Send receipts in a click—especially handy for business clients and airports. Look professional, get repeat business.
                </p>
                
                <h5 className="text-success">✅ Better Customer Experience</h5>
                <p>
                  <strong>Nearest driver can respond</strong> ensuring faster pickups and happier customers. 
                  Better service means more repeat business and referrals for everyone in the network.
                </p>
                
                <h5 className="text-success">✅ Link Jobs, Double Income</h5>
                <p>
                  <strong>Drivers can link jobs</strong> - return journey not empty. 
                  This doubles your potential income while providing better value to customers.
                </p>
                
                <h5 className="text-success">✅ Bespoke Booking Links for Your Clients</h5>
                <p>
                  <strong>Have your own client base?</strong> Create custom booking links for your regular customers 
                  that go directly into your diary. No more phone calls or manual entry—let your clients book 
                  themselves with your personalized link.
                </p>
                
                <h5 className="text-success">✅ Automatic Email Confirmation</h5>
                <p>
                  <strong>Instant professional communication</strong> - when customers book through your link, 
                  they automatically receive email confirmation. No more manual follow-ups or missed bookings. 
                  Your clients get immediate confirmation and you get peace of mind.
                </p>
                
                <h5 className="text-success">💰 Built-In Fare Estimator</h5>
                <p>
                  <strong>Quote accurately, every time!</strong> Journey Estimator uses Google Maps and your official 
                  licensing authority tariffs (East Devon, Dorset, etc.) to calculate accurate fares. Shows all 3 
                  tariffs instantly—no manual calculations needed.
                </p>
                
                <h5 className="text-success">📱 Android Companion App</h5>
                <p>
                  <strong>Incoming call? Instant booking!</strong> Our free Android app detects incoming calls and 
                  automatically opens your diary with the caller's number pre-filled. Book jobs in seconds while 
                  still on the phone with the customer.
                </p>
                
                <h5 className="text-success">💳 Direct Debit Made Easy</h5>
                <p>
                  <strong>Simple, secure payments via GoCardless.</strong> Set up Direct Debit in minutes. First month 
                  only £1, then your chosen subscription level. No complicated payment processing—it just works.
                </p>
                
                <h5 className="text-success">🚛 Dispatch Module for Multiple Cars</h5>
                <p>
                  <strong>Running multiple cars?</strong> No problem with our Dispatch Module! Easily assign jobs to your driver's diaries. 
                  Manage your entire fleet from one central dashboard. Create jobs and dispatch them directly to your drivers' 
                  individual diaries for maximum efficiency and control.
                </p>
              </div>
            </div>
           </div>
         </div>

                   {/* Modern Technology Features */}
          <div className="card mb-4">
            <div className="card-header bg-info text-white text-center">
              <h4 className="mb-0">🚀 Cutting-Edge Technology for Modern Operators</h4>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="text-info">⭐ Smart Customer Management</h5>
                  <p>
                    <strong>Know your customers better!</strong> Comprehensive review system where customers rate their journey 
                    on 6 detailed criteria. View your performance dashboard, track feedback, and build your reputation. 
                    Blacklist problematic customers with full audit trails for your protection.
                  </p>
                  
                  <h5 className="text-info">💰 Intelligent Fare Calculator</h5>
                  <p>
                    <strong>Stop guessing fares!</strong> Built-in Journey Estimator uses Google Maps to calculate distances 
                    and automatically applies your official licensing authority tariffs (East Devon, Dorset, Somerset). 
                    Instantly shows Tariff 1, 2, and 3 options—quote with confidence every time.
                  </p>
                  
                  <h5 className="text-info">📱 Android Companion App</h5>
                  <p>
                    <strong>The ultimate time-saver!</strong> Free Android app detects incoming calls and instantly opens 
                    your MyDiary with the caller's number already filled in. Complete the booking in seconds while still 
                    talking to the customer. Search existing customers automatically—no typing errors!
                  </p>
                  
                  <h5 className="text-info">📍 GPS Location Tracking</h5>
                  <p>
                    <strong>Always in the right place!</strong> Automatic real-time GPS tracking integrated with your profile. 
                    System knows where you are, helping match you with nearby jobs. Updates automatically—no manual input needed.
                  </p>
                </div>
                
                <div className="col-md-6">
                  <h5 className="text-info">🚨 Automatic Job Monitoring</h5>
                  <p>
                    <strong>Never miss a job again!</strong> Set your postcode areas and let the system monitor for new work. 
                    Get instant alerts via screen flash, sound, or email every 5 minutes when jobs appear. Configure 
                    auto-stop to prevent notification overload. Works in the background while you drive!
                  </p>
                  
                  <h5 className="text-info">💳 Seamless Payment Processing</h5>
                  <p>
                    <strong>No payment hassles!</strong> GoCardless Direct Debit integration means your subscription is 
                    handled automatically. First month only £1 trial, then seamless monthly payments. Focus on driving, 
                    not paperwork.
                  </p>
                  
                  <h5 className="text-info">🔗 Custom Booking Links</h5>
                  <p>
                    <strong>Let customers book themselves!</strong> Generate personalized booking links for your regular 
                    clients. Jobs go straight into your diary with automatic email confirmations sent to customers. 
                    Perfect for corporate clients, hotels, and repeat business.
                  </p>
                  
                  <h5 className="text-info">🎯 Smart Job Matching</h5>
                  <p>
                    <strong>Right driver, right job!</strong> System uses your location, postcode coverage, and availability 
                    to match you with suitable jobs. Accept with one tap—no more endless phone calls or missed opportunities.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Flat Playing Field & Quick Start */}
          <div className="card mb-4">
            <div className="card-header bg-primary text-white text-center">
              <h4 className="mb-0">⚖️ Flat Playing Field - No Search Engine Rankings Needed</h4>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="text-primary">🎯 Equal Opportunity for All</h5>
                  <p>
                    <strong>Not at the top of search engines?</strong> No problem! Our system creates a flat playing field where 
                    every operator gets equal access to leads. No expensive SEO, no waiting for rankings—just immediate opportunities.
                  </p>
                  
                  <h5 className="text-primary">⚡ Get Leads Within Hours</h5>
                  <p>
                    <strong>Sign up, get verified, and start receiving leads within hours.</strong> No waiting months for 
                    your business to appear in search results. Our network connects you directly to customers who need your service.
                  </p>
                  
                  <h5 className="text-primary">📱 Instant Market Access</h5>
                  <p>
                    Traditional operators often struggle to compete with big firms that dominate search results. 
                    Our platform bypasses this entirely—customers find you through our network, not search engines.
                  </p>
                </div>
                
                <div className="col-md-6">
                  <h5 className="text-primary">🔄 Continuous Lead Flow</h5>
                  <p>
                    Once verified, you're immediately part of our lead distribution network. No need to build 
                    online presence or wait for customers to find you. The leads come to you automatically.
                  </p>
                  
                  <h5 className="text-primary">🎲 Fair & Randomised Display</h5>
                  <p>
                    <strong>Lists displayed to customers are randomised</strong> giving all operators a fair experience, 
                    again overcoming search engine priorities. Every operator gets equal visibility to customers.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Dispatch Module Benefits */}
          <div className="card mb-4">
            <div className="card-header bg-warning text-white text-center">
              <h4 className="mb-0">🚛 Dispatch Module - Perfect for Multi-Car Operations</h4>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="text-warning">🎯 Centralized Job Management</h5>
                  <p>
                    <strong>Manage your entire fleet from one dashboard.</strong> Create jobs and dispatch them directly 
                    to your drivers' individual diaries. No more phone calls or manual coordination between drivers.
                  </p>
                  
                  <h5 className="text-warning">📱 Driver Diary Integration</h5>
                  <p>
                    <strong>Each driver gets their own secure diary.</strong> Jobs are automatically added to their 
                    individual diaries when dispatched. Drivers can accept, decline, or update job status in real-time.
                  </p>
                  
                  <h5 className="text-warning">🔒 Secure Fleet Management</h5>
                  <p>
                    <strong>Jobs are isolated to your company only.</strong> Each dispatch company only sees and manages 
                    their own jobs and drivers. Complete privacy and security for your operations.
                  </p>
                </div>
                
                <div className="col-md-6">
                  <h5 className="text-warning">⚡ Real-Time Updates</h5>
                  <p>
                    <strong>Instant communication between dispatcher and drivers.</strong> See job status updates, 
                    driver availability, and completion confirmations in real-time. No more guessing or follow-up calls.
                  </p>
                  
                  <h5 className="text-warning">📊 Fleet Performance Tracking</h5>
                  <p>
                    <strong>Monitor your fleet's performance.</strong> Track job completion rates, driver efficiency, 
                    and customer satisfaction. Make data-driven decisions to optimize your operations.
                  </p>
                  
                  <h5 className="text-warning">💰 Maximize Efficiency</h5>
                  <p>
                    <strong>Reduce downtime and increase earnings.</strong> Quickly assign jobs to the most 
                    appropriate driver based on location, availability, and customer preferences.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* One-Man Band Benefits */}
          <div className="card mb-4">
            <div className="card-header bg-info text-white text-center">
              <h4 className="mb-0">🚗 Perfect for One-Man Bands & Traditional Operators</h4>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="text-info">📱 Never Lose Your Diary Again</h5>
                  <p>
                    <strong>Ever lose or mislay your diary?</strong> With our online system, your bookings are safe in the cloud. 
                    Access them from any device, anytime. No more frantic searches or lost business. 
                    <strong>If you want, still print off daily sheets</strong> - get the best of both worlds!
                  </p>
                  
                  <h5 className="text-info">⚡ Instant Professional Receipts</h5>
                  <p>
                    <strong>In a hurry but customer wants a handwritten receipt?</strong> Send professional receipts instantly 
                    via email or SMS. No more scribbling in traffic or messy handwriting. Look professional every time.
                  </p>
                </div>
                
                <div className="col-md-6">
                  <h5 className="text-info">📞 Reduce Phone Calls</h5>
                  <p>
                    Stop being tied to your phone all day. Let the system handle lead distribution while you focus on driving. 
                    Accept jobs with one tap, not endless phone conversations.
                  </p>
                  
                  <h5 className="text-info">💰 Keep More Money</h5>
                  <p>
                    Traditional operators often pay 25%+ to national platforms. We charge just 75p per job. 
                    That's the difference between surviving and thriving in today's competitive market.
                  </p>
                </div>
              </div>
            </div>
          </div>

        {/* Pricing Options */}
        <div className="card mb-4">
          <div className="card-header bg-warning text-center">
            <h4 className="mb-0">Choose Your Membership Level</h4>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-4">
                <div className="card border-warning h-100">
                  <div className="card-header bg-warning text-center">
                    <h5 className="mb-0">📋 Listing Only - £50/year</h5>
                  </div>
                  <div className="card-body d-flex flex-column">
                    <p className="mb-3">
                      <strong>Perfect for operators who want visibility without full integration</strong>
                    </p>
                    <ul className="list-unstyled mb-4">
                      <li>✅ Appear in customer search results</li>
                      <li>✅ Customers receive randomised list of local taxis</li>
                      <li>✅ No full integrated diary system required</li>
                      <li>✅ Basic profile and contact information</li>
                      <li>✅ Local network exposure</li>
                    </ul>
                    <div className="mt-auto">
                      <p className="text-warning fw-bold mb-2">Great for:</p>
                      <ul className="list-unstyled small">
                        <li>• Traditional operators with existing systems</li>
                        <li>• Those who want to test the network first</li>
                        <li>• Operators with their own booking methods</li>
                      </ul>
                      <button
                        className="btn btn-warning btn-lg w-100 mt-3"
                        onClick={handleSubscription}
                      >
                        Signup Now - £50/year
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="col-md-4">
                <div className="card border-success h-100">
                  <div className="card-header bg-success text-white text-center">
                    <h5 className="mb-0">🚀 Full Integration - £25/month</h5>
                  </div>
                  <div className="card-body d-flex flex-column">
                    <p className="mb-3">
                      <strong>Complete taxi management system with full features</strong>
                    </p>
                    <ul className="list-unstyled mb-4">
                      <li>✅ Everything in Listing Only, PLUS:</li>
                      <li>✅ Full integrated online diary system</li>
                      <li>✅ Instant lead distribution</li>
                      <li>✅ Accept/decline jobs with one tap</li>
                      <li>✅ Professional receipts</li>
                      <li>✅ Bespoke booking links</li>
                      <li>✅ Automatic email confirmations</li>
                      <li>✅ Job linking and return journeys</li>
                      <li>⭐ Customer review & blacklist system</li>
                      <li>💰 Built-in fare estimator with council tariffs</li>
                      <li>📍 Real-time GPS location tracking</li>
                      <li>🚨 Automatic job alerts (screen/sound/email)</li>
                      <li>📱 Free Android companion app</li>
                      <li>💳 GoCardless Direct Debit integration</li>
                    </ul>
                    <div className="mt-auto">
                      <p className="text-success fw-bold mb-2">Perfect for:</p>
                      <ul className="list-unstyled small">
                        <li>• Operators wanting full automation</li>
                        <li>• Those ready to modernize their business</li>
                        <li>• Maximum efficiency and earnings</li>
                      </ul>
                      <button
                        className="btn btn-success btn-lg w-100 mt-3"
                        onClick={handleSubscription}
                      >
                        Signup Now - £25/month
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card border-danger h-100">
                  <div className="card-header bg-danger text-white text-center">
                    <h5 className="mb-0">🚛 Dispatch Module - £50/month</h5>
                  </div>
                  <div className="card-body d-flex flex-column">
                    <p className="mb-3">
                      <strong>Multi-car fleet management with dispatch control</strong>
                    </p>
                    <ul className="list-unstyled mb-4">
                      <li>✅ Everything in Full Integration, PLUS:</li>
                      <li>✅ Centralized dispatch dashboard</li>
                      <li>✅ Create and assign jobs to drivers</li>
                      <li>✅ Real-time fleet management</li>
                      <li>✅ Driver diary integration</li>
                      <li>✅ Fleet performance tracking</li>
                      <li>✅ Secure job isolation per company</li>
                      <li>✅ Multi-driver coordination</li>
                    </ul>
                    <div className="mt-auto">
                      <p className="text-danger fw-bold mb-2">Perfect for:</p>
                      <ul className="list-unstyled small">
                        <li>• Multi-car operations</li>
                        <li>• Fleet management companies</li>
                        <li>• Dispatch control centers</li>
                      </ul>
                      <button
                        className="btn btn-danger btn-lg w-100 mt-3"
                        onClick={handleDispatchSubscription}
                      >
                        Signup Now - £50/month
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Pricing Comparison */}
        <div className="card mb-4">
          <div className="card-header bg-danger text-white text-center">
            <h4 className="mb-0">Real Cost Comparison - Based on Actual Journey</h4>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="card border-danger">
                  <div className="card-header bg-danger text-white text-center">
                    <h5 className="mb-0">❌ International Platforms</h5>
                  </div>
                  <div className="card-body">
                    <div className="alert alert-danger">
                      <strong>Real Example:</strong> Customer quoted £18, Actual cost £28-30
                    </div>
                    <ul className="list-unstyled">
                      <li>💸 Customer pays: <strong>£18</strong></li>
                      <li>💸 Platform takes 25%: <strong>£4.50</strong></li>
                      <li>💸 You receive: <strong>£13.50</strong></li>
                      <li>💸 Actual cost should be: <strong>£28-30</strong></li>
                      <li>💸 Your loss: <strong>£14.50-16.50</strong></li>
                    </ul>
                    <p className="text-danger fw-bold">You lose £14.50-16.50 on ONE journey!</p>
                    <p className="text-danger">Monthly loss: £435-495 (30 journeys)</p>
                  </div>
                </div>
              </div>
              
              <div className="col-md-6">
                <div className="card border-success">
                  <div className="card-header bg-success text-white text-center">
                    <h5 className="mb-0">✅ Taxi-Local.uk</h5>
                  </div>
                  <div className="card-body">
                    <div className="alert alert-success">
                      <strong>Same Journey:</strong> You set your own fair price
                    </div>
                    <ul className="list-unstyled">
                      <li>💰 Customer pays: <strong>£28-30</strong> (fair price)</li>
                      <li>💰 We charge: <strong>75p</strong> per job</li>
                      <li>💰 You receive: <strong>£27.25-29.25</strong></li>
                      <li>💰 No hidden fees or commissions</li>
                      <li>💰 You control your pricing</li>
                    </ul>
                    <p className="text-success fw-bold">You keep £27.25-29.25 on ONE journey!</p>
                    <p className="text-success">Monthly gain: £817.50-877.50 (30 journeys)</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="row mt-4">
              <div className="col-12">
                <div className="alert alert-warning text-center">
                  <h5 className="mb-2">📊 Monthly Comparison (30 journeys)</h5>
                  <p className="mb-0">
                    <strong>International Platform:</strong> You lose £435-495 | 
                    <strong>Taxi-Local.uk:</strong> You earn £817.50-877.50
                  </p>
                  <p className="mb-0 fw-bold text-danger">
                    That's a difference of £1,252.50-1,372.50 per month!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="card mb-4">
          <div className="card-body text-center">
            <h4 className="mb-3">Ready to Keep More of Your Earnings?</h4>
            <p className="lead">
              Join our ever growing community of local Cluster operators
            </p>
            <div className="mb-3">
              <span className="badge bg-danger fs-6 me-2">1st month only £1</span>
              <span className="badge bg-success fs-6">No 25% commission</span>
              <span className="badge bg-warning fs-6">GoCardless Direct Debit</span>
            </div>
            <div className="mb-3">
              <p className="text-muted">
                <strong>Dispatch Module:</strong> First month £1, then £50 per month via GoCardless Direct Debit
              </p>
            </div>
            <button
              className="btn btn-success btn-lg me-3"
              onClick={handleDispatchSubscription}
            >
              Start Your £1 Trial
            </button>
            <p className="mt-3">
              <strong>Questions?</strong> Email: <a href="mailto:info@taxi-local.com">info@taxi-local.com</a>
            </p>
          </div>
        </div>

        <div className="text-center">
          <p className="text-muted">
            <strong>Let's build something that works for us—not just the big platforms.</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default BecomeAMember;
